module.exports = __webpack_public_path__ + "static/media/PT.ada259b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PT.svg
// module id = 2244
// module chunks = 7